<template>
  <div class="container-fluid mt-4" style="max-width: 1000px; font-weight: bold">
    <b-card>
      <span style="float:left"><h3>Create A Support Ticket</h3></span>
      <span style="float:right"><b-button variant="success" size="md" :to="{ name: 'support_ticket_list' }"><span style="color:white">Back To List</span></b-button></span>
      <br/><br/><hr/>

      <form @submit.prevent="saveSupportTicket">

        <table cellpadding="10" cellspacing="10" width="100%" style="font-size: 18px">
          <tr v-if="user.role === 'admin'">
            <td align="left" valign="top">
              <h5>Account</h5>
              <b-form-select v-model="selected_tenant_id" :options="user.tenant_options" />
            </td>
            <td align="left" valign="top" colspan="2">
              <h5>Internal Notes</h5>
              <b-form-textarea style="field-sizing: content" v-model="model.internal_notes" />
            </td>
          </tr>
          <tr v-if="user.role === 'admin'">
            <td align="left" valign="top">
              <h5>Created By</h5>
              <span>
                  <b-form-select v-model="model.username" :options="user_options" />
                </span>
            </td>
            <td align="left" valign="top">
              <h5>Assigned To</h5>
              <span v-if="user.role === 'admin'">
                  <b-form-select v-model="model.assigned_to" :options="assignedOptions" />
                </span>
            </td>
          </tr>
          <tr>
            <td align="left" valign="top">
              <h5>Account</h5>
              <span style="margin-top:4px; font-size: 18px">{{getOptionText(user.tenant_options, selected_tenant_id)}}</span>
            </td>
            <td align="left" valign="top" colspan="2">
              <h5>Additional Contacts (comma separated emails)</h5>
              <b-form-input type="text" v-model="model.additional_contacts" />
            </td>
          </tr>
          <tr>
            <td align="left" valign="top">
              <h5>Feature</h5>
              <b-form-select style="width: 250px" v-model="model.category" :options="categoryOptions" />
            </td>
            <td align="left" valign="top">
              <h5>Priority</h5>
              <b-form-select style="width: 250px" v-model="model.priority" :options="priorityOptions" />
            </td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td align="left" valign="top" colspan="3">
              <h5>Your Role (please describe your position for context)</h5>
              <b-form-input type="text" v-model="model.creator_role" />
            </td>
          </tr>
          <tr>
            <td align="left" valign="top" colspan="3">
              <h5>Subject</h5>
              <b-form-input type="text" v-model="model.subject" />
            </td>
          </tr>
          <tr>
            <td align="left" valign="top" colspan="3">
              <h5>Description (text only, use attachments for images, etc)</h5>
              <b-form-textarea style="field-sizing: content" v-model="model.description" />
            </td>
          </tr>
          <tr>
            <td align="left" valign="top" colspan="3">
              <h5>Attachments</h5>
              <input id="comment_attachments" type="file" multiple @change="handleFileUpload" />
            </td>
          </tr>
        </table>
        <br/><br/>
        <div>
          <b-btn type="submit" variant="success">Save</b-btn>
          &nbsp;&nbsp;
          <b-button :to="{ name: 'support_ticket_list' }">
            Cancel
          </b-button>
        </div>
      </form>
    </b-card>
  </div>
</template>

<script>

import {create_support_ticket, get_primary_users} from '../networking/apis'
import {mapState} from "vuex";
import axios from "axios";

export default {
  name: 'support_ticket_create',
  components: {  },
  data () {
    return {
      selected_tenant_id: null,
      user_options: [],
      assignedOptions: [
        { value: null, text: 'Unassigned' },
        { value: 'ben@initekconsulting.com', text: 'Ben ODay' },
        { value: 'jen@initekconsulting.com', text: 'Jen Mayer' },
        { value: 'chaz@initekconsulting.com', text: 'Chaz Watson' },
        { value: 'kai@initekconsulting.com', text: 'Kai Klein' },
        { value: 'evan@initekconsulting.com', text: 'Evan Anderson' },
      ],
      model: { 'category': 'general', 'priority': 'question'},
      attachments: [],      // New comment file attachments
      categoryOptions: [
        {value: 'general', text: 'General'},
        {value: 'actuals', text: 'Actuals'},
        {value: 'alerts', text: 'Alerts'},
        {value: 'maps', text: 'Map Views'},
        {value: 'reports', text: 'View & Reports'},
        {value: 'vsm', text: 'Vehicle Status Manager'},
        {value: 'data', text: 'Data Services'},
        {value: 'fleet-assistant', text: 'Fleet Assistant'},
      ],
      priorityOptions: [
        {value: 'question', text: 'Question/Request'},
        {value: 'minor', text: 'Minor Bug'},
        {value: 'urgent', text: 'Major Bug / System Issue'},
        {value: 'enhancement', text: 'Enhancement Request'},
        {value: 'feature', text: 'New Feature Request'},
      ],
    }
  },
  async created () {
    this.selected_tenant_id = this.user.tenant
    if (this.user.role == 'admin')
      await this.load_users()
  },
  methods: {
    getOptionText(options, value) {
      const option = options.find(opt => opt.value === value)
      return option ? option.text : value
    },
    async load_users() {
      const {value: {data = []}} = await get_primary_users(this.selected_tenant_id)
      if (data.results.length > 0) {
        this.user_options = data.results.map(item => ({
          value: item['username'],
          text: item['first_name'] ? item['first_name'] + ' ' + item['last_name'] + ' - ' + item['username'] : item['username']
        }));
        this.user_options.concat(this.assignedOptions)
      } else {
        this.user_options = this.assignedOptions
      }
    },
    async saveSupportTicket () {
      try{
        this.$emit('showAlert', "waiting for response...", 'info')
        const {value: {data = []}} = await create_support_ticket(this.selected_tenant_id,this.model)
        this.model.id = data.ticket_id

        if (this.attachments.length > 0)
          await this.saveAttachments()

        this.$emit('showAlert', data.message || 'Success!', 'success', 1500)
        this.$router.push({name:'support_ticket_list'})
      } catch(e) {
        this.$emit('showAlert', 'error creating ticket, contact support if needed', 'danger', 5000)
      }
    },
    handleFileUpload(event) {
      this.attachments = Array.from(event.target.files);
    },
    async saveAttachments() {

      try {
        this.$emit('showAlert', "Adding support ticket attachment", 'info')
        this.wait_for_posting = true

        const formData = new FormData();
        formData.append('comment', "initial attachments");
        if (this.attachments) {
          this.attachments.forEach(file => {
            formData.append('attachments', file);
          });
        }

        let xhr = new XMLHttpRequest();
        let url = process.env.VUE_APP_API_URL + 'bookings/support_ticket/comment?tenant=' + this.selected_tenant_id + '&ticket_id=' + this.model.id
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Authorization',`Bearer ${localStorage.getItem('jwt')}`)
        xhr.setRequestHeader('Access-Control-Allow-Origin','*')
        //xhr.setRequestHeader('Access-Control-Allow-Headers','Authorization,Content-type')
        xhr.addEventListener("error", function () {
            console.log("An error occurred while sending the request.");
            this.$emit('showAlert', 'Error adding comment, try again', 'danger')
        }); 
        xhr.onload = function () {
          // do something to response
          //console.log(this.responseText);
        }
        xhr.onloadend  = () => {
          if (xhr.status == 200) {
            console.log("success");
            this.$emit('showAlert', 'Attachment added successfully', 'success', 5000)
            this.newComment = ''
            this.attachments = null
            //document.getElementById('comment_attachments').value= null;
            this.load_data()

          } else {
            console.log("error " + this.status);
          }
        };
        xhr.send(formData);
        this.wait_for_posting = false

      } catch(e) {
        this.$emit('showAlert', 'Error adding comment, try again: ' + e, 'danger', 5000)
        this.wait_for_posting = false
      }
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_users()
      }
    },
    selected_tenant_id() {
      if (this.user.role == 'admin')
        this.load_users()
    }
  }
}
</script>

<style>
a { color: white}
</style>
